export default __webpack_public_path__ + "static/media/sdnn.f1de1ec2.svg";